import {InfoHeaderLazy} from 'app/components/infoHeader/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineInfoHeader(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-info-header')) {
        return;
    }

    customElements.define(
        'gem-info-header',
        class extends WebComponentLoader {
            reactLazyComponent = InfoHeaderLazy;
        },
    );
}
